import { render } from "./NotAvailable.vue?vue&type=template&id=2d76f4d4&lang=pug"
import script from "./NotAvailable.vue?vue&type=script&lang=js"
export * from "./NotAvailable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__